module.exports = __webpack_public_path__ + "static/media/DiasterRelief.57dcf9a6.svg";